export interface MenuColorTheme {
  key: string
  label: string
  navbar: string
  drawer: string
  light?: boolean
  takeNav?: boolean
  reloadOnSelect?: boolean
  filtersHaveCard?: boolean
}

export const menuColorThemes: MenuColorTheme[] = [
  {
    key: 'industrial',
    label: 'Arboris ',
    navbar: 'linear-gradient(145deg, #050529 0%, #071C46 57%, #004C99 140%)',
    drawer: 'linear-gradient(155deg, rgb(5 5 41 / 92%) 0%, rgb(7 25 66 / 94%) 70%, rgb(0 76 153 / 92%) 145%)',
    reloadOnSelect: true,
    filtersHaveCard: true,
  },
  {
    key: 'dotnet',
    label: 'SSW ',
    navbar: '#04173E',
    drawer: 'linear-gradient(147.04deg, #0F1F5F 0.74%, #34094A 99.61%)',
    reloadOnSelect: true,
    filtersHaveCard: false
  },
  {
    key: 'blue',
    label: 'RLA ',
    navbar: 'linear-gradient(147.04deg, #0077BC 0.74%, #262772 99.61%)',
    drawer: 'linear-gradient(147.04deg, rgb(0 75 119 / 80%) 0.74%, #17185f 99.61%)',
    reloadOnSelect: true,
    filtersHaveCard: false
  },
  {
    key: 'chevez',
    label: 'KDL ',
    navbar: '#fff',
    drawer: 'linear-gradient(270deg, #00807e 0, #262772 100%)',
    light: true,
    takeNav: true,
    reloadOnSelect: true,
    filtersHaveCard: false
  },
  {
    key: 'teal',
    label: 'Supply ',
    navbar: 'linear-gradient(147.04deg, #00897B 0.74%, #164E63 99.61%)',
    drawer: 'linear-gradient(147.04deg, rgb(0 121 107 / 80%) 0.74%, #0F2E35 99.61%)',
    reloadOnSelect: true,
    filtersHaveCard: false
  },
  {
    key: 'crimson',
    label: 'Medical ',
    navbar: 'linear-gradient(147.04deg, #C1121F 0.74%, #3F0D12 99.61%)',
    drawer: 'linear-gradient(147.04deg, rgb(163 20 30 / 80%) 0.74%, #2C0A0D 99.61%)',
    reloadOnSelect: true,
    filtersHaveCard: false
  },
  {
    key: 'slate',
    label: 'Legal ',
    navbar: 'linear-gradient(147.04deg, #37474F 0.74%, #10171A 99.61%)',
    drawer: 'linear-gradient(147.04deg, rgb(55 71 79 / 80%) 0.74%, #0C1114 99.61%)',
    reloadOnSelect: true,
    filtersHaveCard: false
  },
]

export const defaultMenuColorTheme = 'industrial'

export function getMenuColorTheme(key: string | null | undefined): MenuColorTheme {
  return menuColorThemes.find(t => t.key === key) ?? menuColorThemes[0]
}
